import Crypto from "crypto-js";
import { AES, mode, pad, enc } from 'crypto-js';
import { Observable } from "rxjs";
import { ImContactsInfo } from "./app-im/model";
export const Key = "12345678876543211234567887650000";//32位
export const Iv = "1234567890000000";

export function encrypt(value) {
  var key = Crypto.enc.Utf8.parse(Key);
  var iv = Crypto.enc.Utf8.parse(Iv);
  var str = Crypto.enc.Utf8.parse(value);
  return Crypto.AES.encrypt(str, key, {
    Iv: iv,
    mode: mode.ECB,
    padding: pad.Pkcs7
  }).ciphertext.toString();

}

export function decrypt(value) {
  var key = Crypto.enc.Utf8.parse(Key);
  var iv = Crypto.enc.Utf8.parse(Iv);
  var encryptedHexStr = Crypto.enc.Hex.parse(value);
  var srcs = Crypto.enc.Base64.stringify(encryptedHexStr);
  var decrypt = Crypto.AES.decrypt(srcs, key, {
    iv: iv,
    mode: mode.ECB,
    padding: pad.Pkcs7
  });
  var decryptedStr = decrypt.toString(Crypto.enc.Utf8);
  return decryptedStr.toString();
}

// 手机号私密保护 隐藏中间4位
export function mobileFormatter(mobile): string {
  const reg = /^(\d{3})\d{4}(\d{4})$/;
  return mobile.replace(reg, '$1****$2');
}

//  邮箱私密保护
export function emailFormatter(email): string {
  const arr = email.split('@');
  let star = '';
  if (arr[0].length <= 3) {
    star = '*';
    arr[0] = arr[0].substr(0, arr[0].length - 1) + star;
  } else {
    star = '***';
    arr[0] = arr[0].substr(0, arr[0].length - 3) + star;
  }
  return email = arr[0] + '@' + arr[1];
}

//时间差
export function timeDifference(beginTime, endTime) {

  if (beginTime > endTime) {
    return 10;
  }
  var begin1 = beginTime.substr(0, 10).split("-");
  var end1 = endTime.substr(0, 10).split("-");
  var date1 = new Date(begin1[1] + - + begin1[2] + - + begin1[0]).valueOf();
  var date2 = new Date(end1[1] + - + end1[2] + - + end1[0]).valueOf();
  var m = Math.abs((date2 - date1) / 1000 / 60);
  var min1 = parseInt(beginTime.substr(11, 2)) * 60 + parseInt(beginTime.substr(14, 2));
  var min2 = parseInt(endTime.substr(11, 2)) * 60 + parseInt(endTime.substr(14, 2));
  var n = min2 - min1;
  var minutes = m + n;
  return minutes;
}

export function generateTaskId() {
  var d = new Date().getTime();
  if (window.performance && typeof window.performance.now === "function") {
    d += performance.now();
  }
  var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
  });
  return uuid;
}

export function formatDate(value, fmt) {
  var o = {
    "M+": value.getMonth() + 1, //月份 
    "d+": value.getDate(), //日 
    "h+": value.getHours(), //小时 
    "m+": value.getMinutes(), //分 
    "s+": value.getSeconds(), //秒 
    "q+": Math.floor((value.getMonth() + 3) / 3), //季度 
    "S": value.getMilliseconds() //毫秒 
  };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (value.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
  return fmt;
}
export function getExtension(filename) {
  var extIndex = filename.lastIndexOf('.');
  var ext = filename.substring(extIndex);
  return ext;
}

export function getFileIco(filename) {
  var ext = getExtension(filename);
  switch (ext) {

    case ".xls":
    case ".xlsx":
      return "./assets/img/chat/file/extension/excel.png";
    case ".mp3":
    case ".wav":
    case ".ogg":
      return "./assets/img/chat/file/extension/music.png";
    case ".pdf":
      return "./assets/img/chat/file/extension/pdf.png";
    case ".ppt":
      return "./assets/img/chat/file/extension/ppt.png";
    case ".rar":
    case ".zip":
    case ".7z":
    case ".bz":
      return "./assets/img/chat/file/extension/rAR.png";
    case ".txt":
      return "./assets/img/chat/file/extension/txt.png";
    case ".doc":
    case ".docx":
      return "./assets/img/chat/file/extension/word.png";
    default:
      return "./assets/img/chat/file/extension/other.png";
  }
}

export function getSize(value) {
  if (null == value || value == '') {
      return "0 Bytes";
  }
  var unitArr = new Array("B", "K", "M", "G", "T", "PB", "EB", "ZB", "YB");
  var index = 0;
  var srcsize = parseFloat(value);
  index = Math.floor(Math.log(srcsize) / Math.log(1024));
  var size = srcsize / Math.pow(1024, index);
  return size.toFixed(2) + unitArr[index];
}


export function readerImageBase64(file: File){
  var reader = new FileReader();
  reader.readAsDataURL(file as any)
  return new Observable<string>((observer) => {
    reader.onload = function (e) {
      observer.next(e.target.result.toString());
      observer.complete();
    }
    reader.onerror = error => observer.error(error);     
  }).toPromise();

  // return new Promise<string>(resolve => {
  //   reader.onload = function (e) {
  //     resolve(e.target.result.toString());
  //   }
  // });
}
